export enum UpdateCustomerStatus {
    None = 0,
    PhoneValidationStarted = 1,
    ValidateMailSentAndDetailsUpdated = 2,
    OnlyDetailsUpdated = 3,
    PhoneAndDetailsUpdatedAndValidateMailSent = 4,
    PhoneAndDetailsUpdated = 5,
    Error = 6,
}
